import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-icon" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "icon-moon icon-chart-arrow" }, null, -1)
const _hoisted_3 = { class: "table-icon" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-moon icon-admin" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "row mt-2 justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tirscript3_loading = _resolveComponent("tirscript3-loading")!
  const _component_filter_component = _resolveComponent("filter-component")!
  const _component_table_header_item = _resolveComponent("table-header-item")!
  const _component_tirscript3_table_body_item = _resolveComponent("tirscript3-table-body-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tirscript3_table = _resolveComponent("tirscript3-table")!
  const _component_tirscript3_pagination = _resolveComponent("tirscript3-pagination")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_component_page, {
    name: 'Список методов',
    selectSource: false
  }, {
    toolbar: _withCtx(() => [
      _createVNode(_component_filter_component, {
        filter: _ctx.filter,
        "onUpdate:filter": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
        selectInterval: false,
        selectLogsFilter: false,
        selectViewFilter: false,
        onFilterData: _ctx.filterData
      }, null, 8, ["filter", "onFilterData"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_tirscript3_loading, { loading: _ctx.isLoading }, null, 8, ["loading"]),
      _createVNode(_component_tirscript3_table, {
        items: _ctx.endpointsResponse,
        style: {"overflow-x":"auto"},
        "template-columns": "150px auto auto auto auto auto 70px 70px"
      }, {
        header: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerItemList, (item, idx) => {
            return (_openBlock(), _createBlock(_component_table_header_item, {
              key: "idx",
              defaultSort: item.defaultSort,
              isNotActiveSort: item.isNotActiveSort,
              sortName: item.sortName,
              onOnSort: _ctx.sort
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["defaultSort", "isNotActiveSort", "sortName", "onOnSort"]))
          }), 128))
        ]),
        body: _withCtx((endpointsResponse) => [
          _createVNode(_component_tirscript3_table_body_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(endpointsResponse.item.EndpointId), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_tirscript3_table_body_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(endpointsResponse.item.EndpointName), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_tirscript3_table_body_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(endpointsResponse.item.NumberOfCalls), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_tirscript3_table_body_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(endpointsResponse.item.AverageTime.toFixed(2)), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_tirscript3_table_body_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(endpointsResponse.item.MaxTime), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_tirscript3_table_body_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(endpointsResponse.item.MinTime), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_tirscript3_table_body_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_router_link, {
                  to: {
                name: 'average-response-time',
                params: {
                  Id: endpointsResponse.item.EndpointId.toString(),
                  Name: endpointsResponse.item.EndpointName,
                  DateFrom: _ctx.endpointsRequest.FromDate,
                  DateTo: _ctx.endpointsRequest.ToDate,
                },
              },
                  title: "Среднее время отклика метода"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_tirscript3_table_body_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_router_link, {
                  to: {
                name: 'users-statistic',
                params: {
                  Id: endpointsResponse.item.EndpointId.toString(),
                  Name: endpointsResponse.item.EndpointName,
                  DateFrom: _ctx.endpointsRequest.FromDate,
                  DateTo: _ctx.endpointsRequest.ToDate,
                },
              },
                  title: "Статистика по пользователям"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["items"]),
      _withDirectives(_createVNode(_component_tirscript3_pagination, {
        ref: "pagination",
        count: _ctx.pageResponse.Count,
        size: _ctx.pageResponse.Size,
        class: "mt-2",
        onOnChange: _ctx.changePage
      }, null, 8, ["count", "size", "onOnChange"]), [
        [_vShow, _ctx.pageResponse.Count > 0]
      ]),
      (!_ctx.error.isSuccess)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error.errorMessage), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}